import * as api from '../../api';
import * as projectActions from './actions';
import { getSelectedIds, getProjects } from './selectors';
import * as lastStateActions from '../lastState/actions';
import { takeLatest } from '../../listenerMiddleware';
import { loadDictionary } from '../filtersCache/loadDictionary';

export const projectListeners = () => {
  watchLoadProjectsRequested();
  watchLastState();
};

function watchLoadProjectsRequested() {
  takeLatest(
    projectActions.loadProjectsRequested,
    async ({ payload }, { getState, dispatch, signal }) => {
      // Список проектов не зависит от фильтров — у него единственный ключ кэша.
      await loadDictionary(
        {
          dict: 'project',
          params: {},
          setLoading: projectActions.setLoading,
          itemsChanged: (projects) => projectActions.projectsChanged({ projects }),
          request: () => api.loadProjects().then((r) => (r.success ? r.data.response : undefined)),
          errorMessage: 'Projects have not been loaded',
          // Пустой сайдбар при сетевой ошибке выглядел бы как «нет доступа к проектам»,
          // поэтому прежний список оставляем на экране.
          clearOnError: false,
        },
        { getState, dispatch, signal },
      );
      if (signal.aborted) {
        return;
      }

      const { saveLastState } = payload;

      // Check selected ids
      const selectedIds = getSelectedIds(getState());
      const projects = getProjects(getState());
      const newSelectedIds = selectedIds.filter((id) =>
        projects.find((project) => project.id === id),
      );
      if (newSelectedIds.join() !== selectedIds.join()) {
        dispatch(projectActions.projectIdsSelected({ ids: newSelectedIds, saveLastState }));
      }
    },
  );
}

function watchLastState() {
  takeLatest(projectActions.expandedChanged, (action, { dispatch }) => {
    dispatch(lastStateActions.saveRequested());
  });
}
